<template>
  <div class="menu-products-list">
    <!-- Struttura annidata delle sottocategorie figlie del menu in questione (e.g. Alla carta, Carta dei vini) -->
    <div
      v-if="actualSubCategory?.children?.length"
      :class="{ '--centered': isCentered }"
    >
      <div
        class="menu-products-list__group"
        v-for="child in parsedChildren(actualSubCategory.children)"
        :key="child.id"
      >
        <!-- Testo introduttivo (opzionale, importato da gestionale) -->
        <!-- Controllo hardcoded orribile ma è una eccezione rispetto ai dati del gestionale, no comment -->
        <div
          v-if="child.descrizione && child.id !== 18"
          class="text-corpo-xl page-piatti-vini-main-intro"
        >
          {{ child.descrizione }}
        </div>

        <!-- Listato della sottocategoria-foglia in questione -->
        <div v-if="child.products.length">
          <h3 class="text-corpo-xl p-bottom-1">
            {{
              useMenuUtils().extractNodeName(
                child,
                isWineList ? 'title' : 'carta-category',
              )
            }}
          </h3>

          <!-- Lista prodotti raggruppati per produttore (vini) -->
          <div v-if="isWineList">
            <ul
              v-for="(
                productGroup, groupKey, groupIndex
              ) in useMenuUtils().groupProductsBySupplier(child.products)"
              :key="groupIndex"
            >
              <li
                v-for="product in productGroup"
                :key="product.idprodotto"
                class="text-corpo-m-2"
              >
                <span class="product-name">{{
                  useMenuUtils().extractNodeName(
                    product,
                    isWineList ? 'wine' : 'product',
                  )
                }}</span
                ><span class="product-price">{{ product.prezzo }}</span>
              </li>
              <li
                v-if="groupKey !== 'null' && groupKey !== 'Eric Forest'"
                class="text-sans-m product-producer"
              >
                {{ groupKey }}
              </li>
            </ul>
          </div>

          <!-- Lista prodotti raggruppati per categoria (alla carta) -->
          <div v-else class="">
            <ul>
              <li
                v-for="product in child.products"
                :key="product.idprodotto"
                class="text-corpo-m-2"
              >
                <span class="product-name">{{
                  useMenuUtils().extractNodeName(product, 'product')
                }}</span
                ><span class="product-price">{{ product.prezzo }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista prodotti sciolti, figli diretti del menu (tipo Menu di Natale, Desgustazione, Desserts ecc) -->
    <div v-else class="menu-products-list__orphan">
      <ul>
        <li
          v-for="product in useMenuUtils().orderMixedProducts(
            actualSubCategory.products,
            menuProducts?.prodotti,
          )"
          :key="product.idprodotto"
          class="text-corpo-m-2"
        >
          <p class="product-name">
            {{ useMenuUtils().extractNodeName(product, 'product') }}
          </p>
          <p
            v-if="actualSubCategory?.menuType !== 'prezzo-fisso'"
            class="product-price"
          >
            {{ product.prezzo }}
          </p>
        </li>
      </ul>

      <div
        v-if="actualSubCategory?.menuType === 'prezzo-fisso'"
        class="p-top-m-1 menu-products-list__orphan__price"
      >
        <span
          >{{ actualSubCategory.prezzo }}
          {{ $t('menu.custom.euro-a-persona') }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesMenuProductsList',
}
</script>

<script setup>
import { useDatoStore } from '@/store/dato.js'
const { menuProducts } = useDatoStore()

const touch = ref(false)

const props = defineProps({
  actualSubCategory: {
    type: Object,
    default: () => ({}),
  },
  isCentered: {
    type: Boolean,
    default: false,
  },
  excludedIds: {
    type: String,
    default: '',
  },
  isWineList: {
    type: Boolean,
    default: false,
  },
})

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
})

// Filtro fuori eventuali IDs di categoria da evitare
const parsedChildren = (children) => {
  if (!props.excludedIds?.length) return children
  return children.filter(
    (child) => !props.excludedIds.split(',').includes(child.id?.toString()),
  )
}
</script>

<style lang="scss">
@import './style.scss';
</style>
